(function() {
  'use strict';

  // .case-studies内の画像追従スクリプト
  const initCaseStudiesScroll = () => {
    const caseStudiesSection = document.querySelector('.case-studies');
    const humanImg = document.querySelector('.case-studies-human-img');

    // 画像の移動速度の倍率（大きいほど早く動く）
    const speedMultiplier = 1.5;

    if (!caseStudiesSection || !humanImg) return;

    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const halfWindowHeight = windowHeight / 2; // ブラウザの高さの半分

      // .case-studiesセクションの位置情報
      const sectionRect = caseStudiesSection.getBoundingClientRect();
      const sectionTop = sectionRect.top + scrollTop;
      const sectionBottom = sectionTop + caseStudiesSection.offsetHeight;

      // 画像の高さを考慮
      const imgHeight = humanImg.offsetHeight;

      // セクションのトップがブラウザの高さの半分（50vh）に達しているかチェック
      // sectionRect.top = セクションの画面上での位置
      const hasReachedHalf = sectionRect.top <= halfWindowHeight;

      if (hasReachedHalf) {
        // セクションが50vhに達した後の処理
        // セクションのトップが50vhの位置にあった時点からのスクロール量を計算
        const startPosition = sectionTop - halfWindowHeight; // 50vhに達した時のscrollTop位置

        // 現在のスクロール位置から開始位置を引いた差分（セクション内のスクロール量）
        let scrollAmount = scrollTop - startPosition;

        // セクションが50vhに達した後の最大スクロール量（画像がボトムに達するまで）
        const maxScrollAmount = sectionBottom - startPosition;

        // スクロール量を制限
        scrollAmount = Math.max(0, Math.min(maxScrollAmount, scrollAmount));

        // 進捗を0から1で計算
        const progress = scrollAmount / (sectionBottom - startPosition);

        // 速度の倍率を適用して範囲内に制限
        const effectiveProgress = Math.min(1, progress * speedMultiplier);

        // 画像の移動可能な範囲
        const maxTop = caseStudiesSection.offsetHeight - imgHeight;

        // 画像の位置を計算
        const newTop = effectiveProgress * maxTop;
        humanImg.style.top = `${newTop}px`;
      } else {
        // まだ到達していない場合は初期位置
        humanImg.style.top = '0px';
      }
    };

    // 初期化
    handleScroll();

    // スクロールイベント
    window.addEventListener('scroll', handleScroll, { passive: true });
  };

  // DOMContentLoaded時に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCaseStudiesScroll);
  } else {
    initCaseStudiesScroll();
  }
})();
